import React from 'react'
import { BottomNavigation, makeStyles, Typography } from '@material-ui/core'

const useStyles = makeStyles(() => ({
    rodape: {
        backgroundColor: '#1F1A17',
        color: '#FFFFFF',
        paddingRight: '20px',
        paddingLeft: '20px',
        paddingBottom: '20px',
        paddingTop: '20px',
        '@media (min-width: 650px)': {
            fontSize: '25px',
        },
        '@media (max-width: 650px)': {
            fontSize: '15px',
        }
    }
}))

export default function Rodape() {
    const { rodape } = useStyles();

    return (
        <BottomNavigation className={rodape}>
            <Typography>Copyright © M A Serviços de Usinagem Ltda.</Typography>
        </BottomNavigation>
    )
}